// based on transition area
export const small_enter = '200ms';
export const small_leave = small_enter;

export const medium_enter = '250ms';
export const medium_leave = '200ms';

export const large_enter = '300ms';
export const large_leave = '250ms';

